import { Mixins, Component } from "vue-property-decorator";
import { $t } from "@/i18n";
import { CommitableDataSlidePanel } from "@/components/slide-panel";
import CavSourcesInfo from '@/lib/models/cav-source-info';
import LabelWithHelp from '@/components/label-with-help';
import XInput from '@/components/x-input';
import { notEmpty } from '@/lib/helpers';

@Component
export default class PanelSourcesInfo extends Mixins<CommitableDataSlidePanel<CavSourcesInfo>>(CommitableDataSlidePanel) {

  async created() {
    this.create && (this.data = new CavSourcesInfo());
    this.validators = [
      {fn: d => notEmpty(d.sourceInformation), message: "Le champ « Source d'information » est requis"},
      {fn: d => notEmpty(d.lieuArchivage), message: "Le champ « Lieu d'archivage » est requis"}
    ];
  }

  mounted() {}

  renderHead() {
    return <span>Source d'information</span>
  }

  renderBody() {
    return (
      <div class="basic">
        <div class="field">
          <LabelWithHelp class="is-small" withIcon={true}
            message={$t("help.label.sourceInfos.refSourceInfo")}
            tooltipPosition="right">
              Source d'information (*)
          </LabelWithHelp>
          <div class="control">
            <XInput vModel={this.data.sourceInformation} class="input is-small" maxLength={255}/>
          </div>
          <p class="help is-small">{$t("help.inline.sourceInfos.refSourceInfo")}</p>
        </div>
        <div class="field">
          <LabelWithHelp class="is-small" withIcon={true}
            message={$t("help.label.sourceInfos.lieuArchivage")}
            tooltipPosition="right">
              Lieu d'archivage (*)
          </LabelWithHelp>
          <div class="control">
            <XInput vModel={this.data.lieuArchivage} class="input is-small" maxLength={100}/>
          </div>
          <p class="help is-small">{$t("help.inline.sourceInfos.lieuArchivage")}</p>
        </div>
      </div>
    );
  }
  
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-6afa218e/panel-sources-info.tsx" });